import { DevTool } from '@hookform/devtools';
import { Box, BoxProps } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { getEnv } from 'util/getEnv';

export type IncFormProps = {
  children: React.ReactNode;
  formMethods: any;
  'data-testid'?: string;
  devTool?: boolean;
} & BoxProps &
  React.HTMLProps<HTMLFormElement>;

const IncForm = ({
  children,
  formMethods,
  'data-testid': dataTestId = 'IncForm',
  // Off by default: @hookform/devtools subscribes to the whole control and
  // corrupts useFieldArray state with our react-hook-form version (a removed
  // item reappears and getValues() desyncs from the rendered array — see the
  // survey builder). Opt in per-form only when debugging a form without arrays.
  devTool = false,
  ...rest
}: IncFormProps) => {
  return (
    <FormProvider {...formMethods}>
      <Box component="form" data-testid={dataTestId} {...rest}>
        {devTool && getEnv('NODE_ENV') === 'development' && (
          /* istanbul ignore next */
          <DevTool control={formMethods.control} />
        )}
        {children}
      </Box>
    </FormProvider>
  );
};
export default IncForm;
